import { render, staticRenderFns } from "./RecoveryView.vue?vue&type=template&id=7931faa2&scoped=true&"
import script from "./RecoveryView.vue?vue&type=script&lang=js&"
export * from "./RecoveryView.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryView.vue?vue&type=style&index=0&id=7931faa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7931faa2",
  null
  
)

export default component.exports